<template>
  <table>
    <thead>
      <th><span class="sortable" :class="$parent.dirClass('name')" @click="$parent.handleSort('name')">Name <span v-html="assets.arrowDropdown"/></span></th>
      <th>Title</th>
      <th>Phone</th>
      <th>Email</th>
    </thead>

    <tbody>
      <tr :key="item.id" v-for="item in items">
        <td>
          <a :href="item.url" v-if="item.url">
            {{ item.name }}
          </a>

          <div v-if="!item.url">
            {{ item.name }}
          </div>
        </td>

        <td>
          {{ item.job_title }}
        </td>

        <td>
          <a :href="`tel:${parsePhoneNumber(item.phone)}`">{{ item.phone }}</a>
        </td>

        <td>
          <a :href="item.contact_url" v-if="item.contact_url">Contact {{ item.first_last_name }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { parsePhoneNumber } from 'scripts/common/util'

export default {
  name: 'DirectoryTableFacultyStaff',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    assets: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    parsePhoneNumber(number) {
      return parsePhoneNumber(number)
    }
  }
}
</script>
